import { render, staticRenderFns } from "./SlideContent.vue?vue&type=template&id=4cfc1350&scoped=true&"
import script from "./SlideContent.vue?vue&type=script&lang=js&"
export * from "./SlideContent.vue?vue&type=script&lang=js&"
import style0 from "./SlideContent.vue?vue&type=style&index=0&id=4cfc1350&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfc1350",
  null
  
)

export default component.exports